import { UserAgentPlatform } from '@sg/shared-utils';

export type PaymentIntentMetadata = {
  // Required
  legacyInternalId: string;
  orderId: string;
  orderType: string;
  amount: number;

  // Payment
  paymentMethodId?: string;
  shouldSetupFutureUsage?: boolean;

  // Environment
  platform: UserAgentPlatform;
  ENV_KEY?: string;

  // Gravy Order
  restaurantId?: string;
  restaurantEntityId?: string;
  restaurantSlug?: string;
  wantedTime?: string;
  contactNumber?: string;
  notificationType?: string;
  dropoffLocationId?: string;
  pickupTip?: number;
  useCredit?: string;
  useHsa?: string;
  includeUtensils?: string;
  addressId?: string;
  vendor?: string;
  vendorRestaurantId?: string;
  deliveryTip?: number;
  deliveryFee?: number;

  // Gift Card
  assetId?: string;
  balance?: number;
  deliveryDateTime?: string;
  deliveryMethods?: string;
  isAsap?: string;
  message?: string;
  quantity?: number;
  recipientEmail?: string;
  recipientName?: string;
  senderName?: string;
  senderEmail?: string;
  utcOffset?: number;
};
